/* eslint-disable import/no-extraneous-dependencies */
import Request from '@gerenciatd/next.utils.request';
import Sonda from '@gerenciatd/next.utils.sonda';


const PATHS = {
  GET_INFO_CONTEXT: '/mimovistar-cliente/publico/api/status/infocontexto',
}

const processName = 'ADABYRON-API';

const getInfoContext = ({
  context,
}) => {
  const sonda = new Sonda({
    eventName: 'CCLI.GETINFOCONTEXT',
    context,
    origin: processName,
  });

  const uniqueUID = `uniqueUID=CT${Date.now()}`;
  const { legadoNoVCM: connectionData, name } = context.environment;
  const { endpoint: host } = connectionData;
  const URL_API = `https://www.movistar.es${PATHS.GET_INFO_CONTEXT}?${uniqueUID}`;

  try {
    const request = new Request({
      method: 'GET',
      endpoint: URL_API,
      sonda,
      headers: {
        withCredentials: true,
        timeout: 2000,
      },
    });

    return request.makeRequest();
  } catch (err) {
    sonda.errorJs(err);
    return null;
  }
};


export default getInfoContext;